/* eslint-disable no-undef */
function addEmail(email, callback) {
  const encodedEmail = encodeURIComponent(email)
  return fetch(`/api/v1/email/addEmail?email=${encodedEmail}`, {
    accept: 'application/json',
  }).then(checkStatus)
    .then(parseJSON)
    .then(callback);
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(`HTTP Error ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
    console.log(error); // eslint-disable-line no-console
    throw error;
  }
}

function parseJSON(response) {
  return response.json();
}

const Email = {
  addEmail,
};
export default Email;



// WEBPACK FOOTER //
// ./src/api/Email.js